export function copyLoginUrl(id) {
  $.ajax({
    url: '/_login_url/'+id,
    type: 'get',
    success: function (data) {
      prompt('One-time login code:', data.url);
    }
  });
}



// WEBPACK FOOTER //
// ./assets/js/user.js